module.exports = __webpack_public_path__ + "img/hczq.227feb3b.png";